import React, { Fragment } from "react";
import PropTypes from "prop-types";

const IHIHistoryRecord = ({ IHIHistoryRecordData }) => (
  <Fragment>
    {IHIHistoryRecordData && IHIHistoryRecordData.length > 0 ? (
      <table className="table table-striped">
        <thead>
          <tr>
            <th scope="col">Updated Date</th>
            <th scope="col">IHI Number</th>
            <th scope="col">Number Status</th>
            <th scope="col">Record Status</th>
            <th scope="col">Operator</th>
          </tr>
        </thead>
        <tbody>
          {IHIHistoryRecordData.map((item, index) => (
            <tr key={index}>
              <td>{new Date(item.createdAt).toLocaleDateString("es-cl")}</td>
              <td>{item.IHINumber}</td>
              <td>{item.IHINumberStatus}</td>
              <td>{item.IHIRecordStatus}</td>
              <td>{item.operator}</td>
            </tr>
          ))}
        </tbody>
      </table>
    ) : (
      <p>No results.</p>
    )}
  </Fragment>
);

export default IHIHistoryRecord;

IHIHistoryRecord.prototype = {
  historyRecord: PropTypes.array
};
